module.exports = __webpack_public_path__ + "static/img/bcg.dc03e087.webp";